var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Project } from '@/models/Project';
import { Component, Vue, Prop } from 'vue-property-decorator';
let ReadRatingDialog = class ReadRatingDialog extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    close() {
        this.$emit('input', false);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], ReadRatingDialog.prototype, "project", void 0);
ReadRatingDialog = __decorate([
    Component({
        name: 'ReadRatingDialog',
    })
], ReadRatingDialog);
export default ReadRatingDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
